import React from 'react'
import styled from 'styled-components'
import Avatar from '@mui/material/Avatar'

const Container = styled.div`
    margin: ${props => props.margin};
    width: ${props => props.size === 'small' ? '35px' : '70px'};
    min-width: ${props => props.size === 'small' ? '35px' : '70px'};
    height: ${props => props.size === 'small' ? '35px' : '70px'};
    min-height: ${props => props.size === 'small' ? '35px' : '70px'};
`

const Img = styled(Avatar)`
	width: 100%;
	height: 100%;
	font-size: 15px;
	background-color: #cadce0;
	color: #95a8ae;
`

const UserImage = ({ type, value, size, margin, onClick, style }) => {
    return (
        <Container size={size} onClick={onClick} margin={margin}>
            {type === 1 ?
                <Img style={style} src={value} /> :
                <Img style={style}>{value}</Img>
            }
        </Container>
    )
}

export default UserImage
